import apiClient from "./client";
import { unwrapApiResponse } from "../utils/apiError";

async function unwrap(request) {
  const response = await request;
  return unwrapApiResponse(response);
}

export const aiAPI = {
  generateExam: (data) => unwrap(apiClient.post("/ai-recommand/generate-exam", data)),
  generateHomework: (data) => unwrap(apiClient.post("/ai-recommand/generate-homework", data)),
  generateImage: (data) => unwrap(apiClient.post("/ai-recommand/generate-image", data)),
  generateLessonPlan: (data) => unwrap(apiClient.post("/ai-recommand/generate-lesson-plan", data)),
  generateLessonSummary: (data) => unwrap(apiClient.post("/ai-recommand/generate-lesson-summary", data)),
};
